import { ChartConstants } from "../shared/constants"

export function depotDefaults() {
  return {
    chart: {
      // alles, was du im Depot anders/konkret brauchst
      // KEIN Highcharts.setOptions hier!
      style: {
        fontFamily: "Open Sans, sans-serif",
        fontSize: ChartConstants.fontSizeKlein,
        fontWeight: 300,
      },
    },

    tooltip: {
      useHTML: true,
      borderRadius: 8,
      split: true,
    },

    plotOptions: {
      series: {
        animation: {
          duration: ChartConstants.animationDuration,
          easing: "easeInOut",
        },
        animationLimit: Infinity,
      },
    },
  }
}